<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter, RouterLink } from 'vue-router'
import { dataManager, type ResourceData } from '@/dataManager'
import ResourceCard from '@/components/ResourceCard.vue'

const emit = defineEmits<{
  (e: 'backButton', backUrl: string|null): void
}>()

const router = useRouter()
const dm = dataManager.getInstance()

onMounted(() => {
  console.log("ResourceRecommended mounted")
  emit('backButton', '/')
})

type ResourceGroup = {
  title: string
  recommendedResources: ResourceData[]
}

const recommendedResourceGroups = calcRecommendedResourceGroups()

function calcRecommendedResourceGroups(): ResourceGroup[] {
  const resourceGroups: ResourceGroup[] = []
  dm.getQuestionnaireList().forEach((questionnaire) => {
    let lastRun = dm.getLastQuestionnaireRun(questionnaire.id)
    let resources = dm.calculateRecommendedResources(lastRun)
    if (resources.length > 0) {
      resourceGroups.push({
        title: questionnaire.title,
        recommendedResources: resources
      })
    }
  })
  return resourceGroups
}
</script>

<template>

  <div class="no-resource-messages" v-if="recommendedResourceGroups.length == 0">
    <p v-if="dm.getPendingQuestionnaires().length == 0">No tenemos nada que recomendarte porque lo has hecho genial. De todas formas, puedes consultar nuestro catálogo completo de recursos desde le menú principal.</p>
    <p v-if="dm.getDoneQuestionnaires().length == 0">Comienza a cubrir cuestionarios para conseguir recomendaciones.</p>
    <p v-if="dm.getDoneQuestionnaires().length > 0 && dm.getPendingQuestionnaires().length > 0">No tienes recursos recomendados por ahora. Sigue cubriendo cuestionarios para conseguir recomendaciones.</p>
  </div>

  <div v-if="recommendedResourceGroups.length > 0">
    <h2>Recomendaciones para ti</h2>

    <div v-for="(recommendationGroup, index) in recommendedResourceGroups">
      <details :open="index == 0">
        <summary>{{ recommendationGroup.title }}</summary>
        <ResourceCard v-for="resource in recommendationGroup.recommendedResources" :resource="resource" />
        <p v-if="recommendationGroup.recommendedResources.length <= 1">Estamos trabajando para ofrecerte más recursos próximamente.</p>
      </details>
    </div>
  </div>

  <RouterLink to="/" class="button">OK</RouterLink>
</template>

<style scoped>
h2 {
  text-align: center;
}

div {
  width: 100%;
  max-width: var(--content-max-width);
}

.no-resource-messages p {
  text-align: center;
}

details {
  margin-top: 15px;
}
summary {
  font-family: var(--title-font);
  color: var(--secondary-color);
  font-size: 13pt;

}
</style>
